export enum FeeInvestmentMenuOption {
  AllPlatform = "AllPlatform",
  FullMenu = "FullMenu",
  LimitedMenu = "LimitedMenu",
}
